import { ChevronLeft } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgArrowButtonLeft1 = mkIcon(ChevronLeft);